import worker from '@/assets/js/volume-process.worker.js'

class VolumeAudioContext {
  constructor() {
    this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
    this.audioContext.audioWorklet.addModule(worker)
    this.volumeNode = {}
    this.startTime = {}
    this.paramterData = {
      clipLevel: 0.98,
      averaging: 0.99,
      clipLag: 750
    }
  }

  addAudioTrack (key, audioTrack, callback) {
    if (!key || !audioTrack) {
      console.log('please to confirm has audiorack key and audiotrack')
      return
    }
    if (!this.audioContext || this.audioContext.state === 'closed') return
    // 浏览器不允许自动播放，所以要添加 resume
    if (this.audioContext.state === 'suspended') this.audioContext.resume()
    // 清楚老的数据并释放掉
    this.destroyVolumeNode(key)
    this.startTime[key] = new Date().getTime()
    this.volumeNode[key] = new AudioWorkletNode(this.audioContext, 'volume-processor', {
      processorOptions: this.paramterData
    })
    const mediaStream = new MediaStream()
    mediaStream.addTrack(audioTrack)
    const mediaStreamSource = this.audioContext.createMediaStreamSource(mediaStream)
    mediaStreamSource.connect(this.volumeNode[key]).connect(this.audioContext.destination)
    if (callback) {
      this.volumeNode[key].port.onmessage = event => {
        const data = event.data
        if (data) {
          const volumeLeft = this.dealVolume(data.volume[0])
          const volumeRight = this.dealVolume(data.volume[1])
          const currentTime = new Date().getTime()
          if (currentTime - this.startTime[key] > 100) {
            this.startTime[key] = currentTime
            callback(volumeLeft, volumeRight)
          }
        }
      }
    }
  }

  dealVolume (volume) {
    const percentage = Math.floor(Math.pow(10, (239 + 100) / 100) * 0.04093171969) / 100
    return volume * percentage
  }

  destroyVolumeNode (key) {
    if (this.volumeNode[key]) {
      this.volumeNode[key].disconnect()
      this.volumeNode[key].port.close()
      this.startTime[key] = 0
    }
  }

  destroyAudioContext () {
    Object.keys(this.volumeNode).forEach(key => {
      this.volumeNode[key].disconnect()
      this.volumeNode[key].port.close()
      this.startTime[key] = 0
    })
    if (this.audioContext && this.audioContext.state !== 'closed') this.audioContext.close()
  }
}

export default VolumeAudioContext